import React from 'react'

// import SearchBar from '../components/SearchBar'

export default function Home() {
      return (
            <div data-testid="home">
                  <h1 className="text-5xl my-12 font-serif">Welcome to Pokedex on React web</h1>
                  {/* <SearchBar /> */}
            </div>
      )
}

